import { signal } from '@angular/core';
import type { WritableSignal } from '@angular/core';

export abstract class DatePickerInterface {

  /**
   * Unique id set for each datepicker
   */
  uniqueId: string;

  /**
   * Signal that fires true when the date picker input should be focused.
   * Consumers should reset to false after handling to allow re-triggering.
   */
  readonly focusRequested: WritableSignal<boolean> = signal(false);

  /**
   * Focuses date picker input
   */
  focusInput(): void {
    this.focusRequested.set(true);
  }
}
